import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import useAuth from '@frolight/hooks/useAuth';
import useFormattedLocalizedText from '@frolight/hooks/useLocalizedFormattedText';
import useRefreshToken from '@frolight/hooks/useRefreshToken';

const PersistLogin = () => {
  const { auth } = useAuth();
  const { lftext } = useFormattedLocalizedText();
  const refreshAccessToken = useRefreshToken();

  const [ loading, setLoading ] = useState(true);

  useEffect(() => {
    const abortController = new AbortController();
    let mounted = true;

    const runEffect = async () => {
      try {
        await refreshAccessToken(abortController);
      } catch (err) {
        if (!abortController.signal.aborted) {
          console.error(err);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    }

    if (!auth?.accessToken) {
      runEffect();
    } else {
      setLoading(false);
    }

    return () => {
      abortController.abort();
      mounted = false;
    }
  }, []);

  if (loading) {
    return <p>{ lftext('common.loading') }</p>;
  }

  return <Outlet />;
};

export default PersistLogin;
